"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiSelectOverrides = function (_a) {
    var palette = _a.palette, spacing = _a.spacing, pxToRem = _a.typography.pxToRem;
    var iconSize = 24;
    return {
        select: {
            "&:focus": {
                borderRadius: undefined,
                backgroundColor: undefined,
            },
        },
        selectMenu: {
            height: undefined,
        },
        outlined: {
            // MUI uses the same for specificity
            "&&": {
                paddingRight: spacing(8),
            },
            "&.MuiInputBase-inputAdornedEnd": {
                paddingRight: spacing(16),
            },
        },
        icon: {
            fontSize: pxToRem(iconSize),
            color: palette.text.secondary,
        },
        iconOutlined: {
            // The actual icon size is larger than the space so we have to calculate correct margin
            right: spacing(4) - (iconSize - spacing(4)) / 2,
        },
    };
};
//# sourceMappingURL=MuiSelect.js.map